export default __webpack_public_path__ + "static/media/leave-contest.d64e718f.mp4";